import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { SIGNIN_URL } from '../siteConfig';

const { FiHome, FiDollarSign, FiGrid, FiLogIn, FiCalendar } = FiIcons;

const tabs = [
  { label: 'Home', icon: FiHome, href: '#/', match: ['', '#', '#/'] },
  { label: 'Services', icon: FiGrid, href: '#/services', match: ['#/services'] },
  { label: 'Pricing', icon: FiDollarSign, href: '#/pricing', match: ['#/pricing'] },
  { label: 'Book', icon: FiCalendar, href: '#/book', match: ['#/book'] }
];

function MobileTabBar() {
  const [hash, setHash] = React.useState(window.location.hash);

  React.useEffect(() => {
    const onHash = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  return (
    <nav className="tab-bar" aria-label="Main">
      {tabs.map((t) => (
        <a key={t.label} href={t.href} className={t.match.includes(hash) ? 'tab-item on' : 'tab-item'}>
          <SafeIcon icon={t.icon} />
          <span>{t.label}</span>
        </a>
      ))}
      <a href={SIGNIN_URL} className="tab-item">
        <SafeIcon icon={FiLogIn} />
        <span>Sign in</span>
      </a>
    </nav>
  );
}

export default MobileTabBar;
